import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, SupplierAddEdit} from './Pages';

export const ExportSupplierRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={Listing}/>
        <Route exact path = {`${match.path}/supplierAddEdit/:id?`} component={SupplierAddEdit} />
    </Fragment>
)